import { InstallationReferenceObj } from "scrivito/Objs/InstallationReference/InstallationReferenceObjClass"

import { BuildingType } from "./references/BuildingType"
import { RoomType } from "./references/RoomType"

export const ProductPositionInstallationReferenceAPIType =
  "product_references" as const

export const ProductPositionInstallationReferenceTypename =
  "ProductPositionInstallationReference" as const

export interface InstallationReference {
  id: string
  title: string
  variantKey: string
  roomImage: React.ReactNode
  detailImage: React.ReactNode
  roomType: RoomType[]
  buildingType: BuildingType[]
  /** Do not use unless necessary */
  __obj?: InstallationReferenceObj
}
